import { clearUserData } from '../PermissionContext';

/**
 * Logs the user out by clearing locally stored session data
 * and redirects to the login page.
 */
export const logoutAndRedirect = (): void => {
  try {
    // Clear consolidated user data for permissions
    clearUserData();
  } catch {}

  try {
    // Best-effort cleanup of legacy keys used across the app
    localStorage.setItem('userid', JSON.stringify(null));
    localStorage.setItem('userId', JSON.stringify(null));
    localStorage.setItem('token', JSON.stringify(null));
    localStorage.setItem('itemSubCategoryId', JSON.stringify(null));
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userid');
    localStorage.removeItem('token');
    localStorage.removeItem('itemSubCategoryId');
  } catch {}

  // Redirect to login route
  try {
    window.location.href = '/';
  } catch {}
};


